import { registerSurfaceItem } from "@/lib/surfaces";
import { lazyNamed } from "@/lib/lazyNamed";

/** US-010 — employees domain dashboard contribution. */
registerSurfaceItem("dashboard-stats", {
  id: "employees",
  order: 30,
  Component: lazyNamed(
    () => import("./EmployeesStatCard"),
    "EmployeesStatCard",
  ),
});
